export const useType = function () {
  return {
    types: ["ad", "editorial"],
  }
}
